/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PaymentStatusModelIEnumerableResponseWrapper } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class PaymentStatuses<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Payment
   * @name GetPaymentStatuses
   * @request GET:/PaymentStatuses
   */
  getPaymentStatuses = (params: RequestParams = {}) =>
    this.request<PaymentStatusModelIEnumerableResponseWrapper, any>({
      path: `/PaymentStatuses`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
